export const BACKEND_URL = 'https://backend.medipuzzle.com/api/v1';

export const BLOG_LIST = '/public/blog/all/?limit=1000';

export const BACKEND_DOMAIN = 'https://backend.medipuzzle.com/';
